import { KeycloakClient } from '@react-keycloak/keycloak-ts';
import { getConfig } from 'configs';

const config = getConfig(process.env.REACT_APP_ENVIRONMENT ?? 'mock');
const keycloak = new KeycloakClient(config.keycloak);

export default keycloak;
